import { render, staticRenderFns } from "./FromStatus.vue?vue&type=template&id=2247796e&"
import script from "./FromStatus.vue?vue&type=script&lang=js&"
export * from "./FromStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports